<template>
    <svg class="bottom-shape" xmlns="http://www.w3.org/2000/svg" width="1560" height="247" viewBox="0 0 1560 247" :fill="fill">
        <path d="M1560 1.25592C1399.62 -9.17063 1235.75 45.7595 1116.95 149.771C947.746 53.7066 749.841 4.87978 553.397 10.7924C356.952 16.705 162.603 77.2934 0 183.403L0 247H1559.94V1.25592H1560Z"/>
    </svg>
</template>

<script>
export default {
    name: "ShapeBrand",

    data() {
        return {
            fill: 'currentColor'
        }
    },
}
</script>